export default {
    examinationOfThreeChromosomes : 'بررسی سه کروموزوم',
    checkAllChromosomes: 'بررسی تمام کروموزوم‌ها',
    pGSType: 'نوع PGS',
    description: 'توضیحات',
}